import { lazy } from 'react';

const ForecastEntries = lazy(() => import('../pages/ForecastEntries/index'));

const forecastEntriesRoute = {
  public: [],
  auth: [
    {
      name: 'forecast_entries',
      path: '/finance-and-account/forecast-entries',
      component: ForecastEntries,
    },
  ],
};

export default forecastEntriesRoute;
